import React from 'react';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom';
import { ConnectedRouter } from 'connected-react-router';
import AppWrapper from 'js/containers/legacy/AppWrapper';
import { beginListeningForDeviceChanges } from 'js/store/actions/device';
import store, { history } from './store';
import RootLayout from './router';
beginListeningForDeviceChanges();

var App = function App() {
  return React.createElement(Provider, {
    store: store
  }, React.createElement(ConnectedRouter, {
    history: history
  }, React.createElement(AppWrapper, null, React.createElement("main", {
    id: "page-wrap"
  }, React.createElement(RootLayout, {
    store: store,
    history: history
  })))));
};

ReactDOM.render(React.createElement(App, null), document.getElementById('app'));